<template>
    <path fill-rule="nonzero"
          d="M5.5 3a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zm0 7.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zm0 7.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/>
</template>

<script>
export default {
    name: 'moreIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 6 21');
    }
};
</script>
